module.exports = __webpack_public_path__ + "img/2-1.9ca0489.png";